// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__341rr","rootCenter":"LoadMoreObserver_rootCenter__3Snq-","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__24JkW"};